<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="formInline.keyword" placeholder="请输入问题或解析" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="formInline.mobile" placeholder="请输入手机" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="未回复" value="10"></el-option>
            <el-option label="已回复" value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="plan_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="70">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户" width="150">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="联系手机" width="120"></el-table-column>
          <el-table-column prop="content" label="内容" width="200">
            <template slot-scope="scope">
              <p class="f16">内容：{{ scope.row.content }}</p>
              <p v-if="scope.row.reply" class="blue f14">回复：{{ scope.row.reply }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="60" align="center">
            <template slot-scope="scope">
              <span class="orange" v-if="scope.row.status == 10">未回复</span>
              <span class="gray9" v-else>已回复</span>
            </template>
          </el-table-column>
          <el-table-column prop="reply_time" label="回复时间" width="140" sortable="custom"></el-table-column> -->
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/study/questioncorrection/reply'">回复</el-button>
              <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import PlanApi from '@/api/study/plan.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          keyword: '',
          mobile: '',
          status: ''
        },
        /*时间*/
        create_time: '',
        open_edit: false,
        typeData: []
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      // 默认
      let type = this.$db.getRouteField(this, 'type');
      if (type) this.formInline.type = type;

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.record_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        PlanApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
          self.typeData = data.type;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

      /*打开编辑*/
      editClick(item) {
        this.selectModel = item;
        this.open_edit = true;
      },

      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.type = e;
        this.$db.setRoute(this, {'type': e});
        this.getTableList();
      },

      /*删除*/
      deleteFun(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          FeedbackApi.del({id: row.id}, true)
              .then(data =>{
                self.loading = false;
                self.$message({
                    message: data.msg,
                    type: 'success'
                });
                self.getTableList();
              })
              .catch(error =>{
                self.loading = false;
              });
        }).catch(() => {});
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/plan/index.vue